<template>
  <div class="content-center">
    <b-spinner
      :variant="variant"
      label="Text Centered"
    />
    <span
      v-if="message"
      class="ml-1"
    >{{ message }}</span>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'ESpinner',
  components: { BSpinner },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    message: {
      type: String,
      default: null,
    },
  },
}
</script>
